export default function Card(props: { title: string; body: string }) {
  return (
    <div className='h-100% md:max-w-sm min-h-sm p-8 border-2 rounded-lg shadow hover:shadow-lg border-gray-200 bg-white'>
      <p className='mb-4 text-xl sm:text-2xl font-bold text-gray-900 tracking-wide max-sm:text-center'>
        {props.title}
      </p>
      <p className='font-medium text-black leading-relaxed max-sm:text-sm max-sm:text-center'>
        {props.body}
      </p>
    </div>
  )
}
